import { clear } from 'idb-keyval'

import { KEY as NOTES_KEY } from './notes'
import { KEY as RECENT_USERS_KEY } from './recentUsers'

export * from './activity'
export * from './drafts'
export { getNoteOrder, setNoteOrder } from './notes'
export { addRecentUser, getRecentUsers } from './recentUsers'

// These keys will not be cleared when clearing drafts
export const NON_DRAFT_KEYS = [
  'tasks',
  'contacts',
  'pinnedTabs',
  NOTES_KEY,
  RECENT_USERS_KEY
]

// Clears everything from indexed db
export const clearAll = async () => {
  try {
    await clear()
  } catch (err) {
    console.error('Error clearing db', err)
  }
}
